// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__2k2d4","sendOtp":"AuthorizeToLogin_sendOtp__dk8A7"};